module.exports = __webpack_public_path__ + "static/tara2-75a2bd24d036eef4c160be840fe2b35a.png";